export default "__VITE_ASSET__BdDukZ2n__"